import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import { neutralColors } from '../../styles/colors/colors.js';
import { BreadcrumbItemBase } from './BreadcrumbItemBase.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["as", "children", "isFirst", "isLast", "label", "tooltipProps"];
var defaultElement = "a";
var BreadcrumbItem = /*#__PURE__*/React.forwardRef(function BreadcrumbItem2(props, ref) {
  var _props$as = props.as,
      LinkComponent = _props$as === void 0 ? defaultElement : _props$as;
      props.children;
      var isFirst = props.isFirst,
      isLast = props.isLast,
      label = props.label,
      tooltipProps = props.tooltipProps,
      rest = _objectWithoutProperties(props, _excluded);

  var _React$useState = React.useState(label),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      tooltipContent = _React$useState2[0],
      setTooltipContent = _React$useState2[1];

  var textRef = React.useRef(null);
  var styleOverides = {
    color: isLast ? neutralColors.charcoal : neutralColors.smoke,
    display: "inline-block",
    fontWeight: isLast ? 600 : 400,
    lineHeight: "inherit",
    maxWidth: isLast ? "inherit" : 240,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  };
  React.useEffect(function () {
    if (typeof label === "string") return;
    if (textRef.current) setTooltipContent(textRef.current.innerText);
  }, [label]);
  return /*#__PURE__*/jsx(BreadcrumbItemBase, {
    isFirst: isFirst,
    isLast: isLast,
    ref: ref,
    children: /*#__PURE__*/jsx(Tooltip, _objectSpread(_objectSpread({
      content: tooltipContent,
      variant: "dark",
      position: "bottom"
    }, tooltipProps), {}, {
      children: /*#__PURE__*/jsx(LinkComponent, _objectSpread(_objectSpread(_objectSpread({
        style: styleOverides
      }, rest), LinkComponent !== "a" ? {
        label: label
      } : {}), {}, {
        ref: textRef,
        children: label
      }))
    }))
  });
});
BreadcrumbItem.propTypes = {
  "as": _PropTypes.oneOfType([_PropTypes.string, _PropTypes.func, _PropTypes.object]),
  "children": _PropTypes.node,
  "isFirst": _PropTypes.bool,
  "isLast": _PropTypes.bool,
  "label": _PropTypes.node,
  "tooltipProps": _PropTypes.object
};
BreadcrumbItem.displayName = "BreadcrumbItem";

export { BreadcrumbItem, defaultElement };
